import {SETTOKENS} from './mutation.type';

export default {
    [SETTOKENS](state, tokens) {
        state.tokens = tokens
    }
}